/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DuplicateObjectRequest } from '../models/DuplicateObjectRequest';
import type { MoveObject } from '../models/MoveObject';
import type { ObjectCreate } from '../models/ObjectCreate';
import type { ObjectOrder } from '../models/ObjectOrder';
import type { ObjectOut } from '../models/ObjectOut';
import type { ObjectPatch } from '../models/ObjectPatch';
import type { ObjectWithReferences } from '../models/ObjectWithReferences';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ItemsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get All Objects
     * @returns ObjectWithReferences Successful Response
     * @throws ApiError
     */
    public getAllObjectsApiV1ItemsAllGet(): CancelablePromise<Array<ObjectWithReferences>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/items/all',
        });
    }
    /**
     * Get Object By Id
     * @returns ObjectOut Successful Response
     * @throws ApiError
     */
    public getObjectByIdApiV1ItemsIdIdGet({
        id,
    }: {
        id: number,
    }): CancelablePromise<ObjectOut> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/items/id/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Edit Object By Id
     * Only supply entries in the json for values you want to write.
     * If a value is `null`, it will actually be written to the database like that.
     * Returns the old values of the changed fields.
     * @returns any Successful Response
     * @throws ApiError
     */
    public editObjectByIdApiV1ItemsIdIdPatch({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: ObjectPatch,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/items/id/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remove Object By Id
     * Returns the old values of the removed object before it was deleted.
     * @returns ObjectOut Successful Response
     * @throws ApiError
     */
    public removeObjectByIdApiV1ItemsIdIdDelete({
        id,
    }: {
        id: number,
    }): CancelablePromise<ObjectOut> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/items/id/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Objects Which Are In Container
     * @returns ObjectOut Successful Response
     * @throws ApiError
     */
    public getObjectsWhichAreInContainerApiV1ItemsChildrenGet({
        id,
    }: {
        /**
         * Keep empty to get the root.
         */
        id?: (number | null),
    }): CancelablePromise<Array<ObjectOut>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/items/children/',
            query: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create New Object
     * Returns the id of the created entry.
     * @returns number Successful Response
     * @throws ApiError
     */
    public createNewObjectApiV1ItemsPut({
        requestBody,
    }: {
        requestBody: ObjectCreate,
    }): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/items/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Duplicate Object
     * Duplicate an object and add second references to its images and attachments.
     * @returns ObjectWithReferences Successful Response
     * @throws ApiError
     */
    public duplicateObjectApiV1ItemsDuplicateIdPost({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: (DuplicateObjectRequest | null),
    }): CancelablePromise<ObjectWithReferences> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/items/duplicate/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Move Object
     * Move an object to a new parent container. Set move_to to null or negative to move to root.
     * @returns any Successful Response
     * @throws ApiError
     */
    public moveObjectApiV1ItemsMovePut({
        requestBody,
    }: {
        requestBody: MoveObject,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/items/move',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reorder Objects
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderObjectsApiV1ItemsOrderPut({
        requestBody,
    }: {
        requestBody: ObjectOrder,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/items/order',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Change Box
     * Set or clear the box reference for an object.
     * @returns any Successful Response
     * @throws ApiError
     */
    public changeBoxApiV1ItemsBoxPut({
        requestBody,
    }: {
        requestBody: MoveObject,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/items/box',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
